import "../constants.js";
import { labelText, mutedValueText } from "../../../i18n/text/volume.js";
import { SliderCore } from "../slider/core.js";
import { defaults } from "@videojs/utils/object";
import { formatPercent } from "@videojs/utils/percent";
//#region src/core/ui/volume-slider/core.ts
/**
* Volume-domain slider: maps media volume/mute state to slider state.
*
* @internal
*/
var VolumeSliderCore = class VolumeSliderCore extends SliderCore {
	static defaultProps = {
		...SliderCore.defaultProps,
		label: "",
		step: 5,
		wheelStep: 5
	};
	#wheelStep = VolumeSliderCore.defaultProps.wheelStep;
	#media = null;
	#formatLocale;
	constructor(props) {
		super();
		if (props) this.setProps(props);
	}
	setProps(props) {
		const resolvedProps = defaults(props, VolumeSliderCore.defaultProps);
		this.#wheelStep = resolvedProps.wheelStep;
		super.setProps(resolvedProps);
	}
	setMedia(media) {
		this.#media = media;
	}
	/** @internal Platform adapters set the active i18n locale for `aria-valuetext` percent formatting. */
	setFormatLocale(locale) {
		this.#formatLocale = locale;
	}
	getState() {
		const media = this.#media;
		const { volume, muted } = media;
		const effectivelyMuted = muted || volume === 0;
		const { dragging, dragPercent } = this.input;
		const volumePercent = volume * 100;
		const value = dragging ? this.valueFromPercent(dragPercent) : volumePercent;
		const base = super.getSliderState(value);
		const availability = media.volumeAvailability;
		return {
			...base,
			disabled: base.disabled || availability !== "available",
			fillPercent: effectivelyMuted ? 0 : base.fillPercent,
			volume,
			muted: effectivelyMuted,
			availability,
			hidden: availability !== "available"
		};
	}
	/** Wheel step as a percentage of the slider range. */
	getWheelStepPercent() {
		const { min, max } = this.props;
		const range = max - min;
		return range > 0 ? this.#wheelStep / range * 100 : 0;
	}
	getLabel(state) {
		return super.getLabel(state) || labelText;
	}
	getValueText(state) {
		return state.muted ? mutedValueText : this.getValueTextParams(state).percent;
	}
	getValueTextParams(state) {
		return { percent: formatPercent(state.value / 100, this.#formatLocale) };
	}
	getAttrs(state) {
		return {
			...super.getAttrs(state),
			"aria-valuetext": this.getValueText(state)
		};
	}
};
//#endregion
export { VolumeSliderCore };

//# sourceMappingURL=core.js.map